export default function PlayPieceMark({ className }: { className?: string }) {
  return (
    <svg className={className} width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
      <path d="M0 0h32L16 16Z" fill="#7AB543" />
      <path d="M32 0v32L16 16Z" fill="#FFCE28" />
      <path d="M32 32H0l16-16Z" fill="#067DBF" />
      <path d="M0 32V0l16 16Z" fill="#E4332F" />
    </svg>
  )
}
